export const SPA_LOGIN_ENDPOINT = '/umbraco/api/SpaAuth/Login';
export const SPA_REFRESH_ENDPOINT = '/umbraco/api/SpaAuth/Refresh';
export const SPA_LOGOUT_ENDPOINT = '/umbraco/api/SpaAuth/Logout';
export const SPA_RESET_PASSWORD_ENDPOINT = '/umbraco/api/SpaAuth/RequestPasswordReset';
export const SPA_VALIDATE_RESET_TOKEN_ENDPOINT = '/umbraco/api/SpaAuth/ValidateResetToken';
export const SPA_CHANGE_PASSWORD_ENDPOINT = '/umbraco/api/SpaAuth/ChangePassword';
export const SPA_ACCOUNT_ACTIVATION_ENDPOINT = '/umbraco/api/SpaAccountActivation/Process';

export const ACCESS_TOKEN_KEY = 'access_token';
export const TOKEN_EXPIRY_KEY = 'token_expiry';

export const LOGIN_LOGO_LIGHT_URL = '/Content/icons/logo.png';
export const LOGIN_LOGO_DARK_URL = '/Content/icons/dark_logo.svg';

// Buffer (in seconds) before expiry when a background refresh should be triggered
export const REFRESH_BUFFER_SECONDS = 60;

// Password reset cooldown
export const PASSWORD_RESET_COOLDOWN_MINUTES = 60;
export const PASSWORD_RESET_COOLDOWN_KEY_PREFIX = 'pwreset_cooldown_';
